import { Component, Input } from "@angular/core";
import { dataTableInfoMock } from "../../mocks/data-table-info.mock";

@Component({
    selector: "pl-fake-data-table",
    templateUrl: "./fake-data-table.component.html",
    styleUrls: ["./fake-data-table.component.scss"],
    standalone: false
})
export class FakeDataTableComponent {
  @Input() isButtonActive!: boolean;
  dataTableInfo = dataTableInfoMock;
  groups = [
    {
      name: "Nome",
      items: this.dataTableInfo[0],
    },
    {
      name: "Logon",
      items: this.dataTableInfo[1],
    },
    {
      name: "Email",
      items: this.dataTableInfo[2],
    },
    {
      name: "Perfil de usuário",
      items: this.dataTableInfo[3],
    },
    {
      name: "Status da conta",
      items: this.dataTableInfo[4],
    },
    {
      name: "Status do MFA",
      items: this.dataTableInfo[5],
    },
    {
      name: "Ações",
      items: this.dataTableInfo[6],
    },
  ];

  isProfile(item: string) {
    return ["Usuário", "Administrador", "Gestor de Contrato"].includes(item);
  }

  isMfaStatus(item: string) {
    return ["Ativado", "Desativado", "Indisponível"].includes(item);
  }

  getMfaStatusClass(item: string) {
    const classMap: Record<string, string> = {
      "Ativado": "--enabled",
      "Desativado": "--disabled",
      "Indisponível": "--unknown"
    };
    return classMap[item] || "";
  }

  getMfaTourId(item: string, rowIndex: number): string {
    if (item === "Ativado" && rowIndex === 0) {
      return "tour-4-1-enabled";
    }
    if (item === "Desativado" && rowIndex === 2) {
      return "tour-4-1-disabled";
    }
    if (item === "Indisponível" && rowIndex === 4) {
      return "tour-4-1-unknown";
    }
    return "";
  }
}
